
<script>
import { mapState } from "vuex"
import { isMobile } from 'mobile-device-detect'

export default {
  data () {
    return {
      isMobile: isMobile,
    }
  },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      buscaremails: state => state.moduleEmail.buscaremails,
    }),
  },
  created() {

  },
  methods: {
    showModal() {
      this.$store.dispatch(
        "BUSCAREMAILS", {codigoUsuario: this.usuario.codUsuario, cidade: this.user.cidade}
      ).then(() => {
        this.$bvModal.show('modal-consulta')
      })

    },
    hideModal() {
      this.$bvModal.hide('modal-consulta')
    },
  },
  watch: {
  }

}
</script>

<template>
  <div class="botao-inline">
    <b-button class="separador_botao" @click="showModal" variant='primary'>Consultar</b-button>
    <b-modal id="modal-consulta" hide-footer size="xl" scrollable v-if="!isMobile" > <!-- computador -->
      <template #modal-title>
        Emails Cadastrados
      </template>
      <b-container fluid>
        <b-row class="mb-1">
          <b-col class='titulo'>Placa</b-col>
          <b-col class='titulo'>Cor</b-col>
          <b-col class='titulo'>Modelo</b-col>
          <b-col class='titulo'>Nome</b-col>
          <b-col class='titulo'>Empresa</b-col>
          <b-col class='titulo'>Email</b-col>
          <b-col class='titulo'>Telefone</b-col>
        </b-row>

        <b-row class="mb-1" v-for="(email, i)  in buscaremails" :key="i">
          <b-col>{{email.placa}}</b-col>
          <b-col>{{email.cor}}</b-col>
          <b-col>{{email.modelo}}</b-col>
          <b-col>{{email.nome}}</b-col>
          <b-col>{{email.empresa}}</b-col>
          <b-col>{{email.email}}</b-col>
          <b-col>{{email.telefone}}</b-col>
        </b-row>
      </b-container>

      <b-button class="mt-3" block @click="hideModal">Fechar</b-button>
    </b-modal>
    <b-modal id="modal-consulta" hide-footer size="xl" scrollable v-else> <!-- mobile -->
      <template #modal-title>
        Emails Cadastrados
      </template>
      <b-container fluid>
        <b-row class="mb-1">
          <b-col class='titulo' cols=3>Placa</b-col>
          <b-col class='titulo' cols=3>Nome</b-col>
          <b-col class='titulo' cols=3>Empresa</b-col>
          <b-col class='titulo' cols=3>Email</b-col>
        </b-row>

        <b-row class="mb-1" v-for="(email, i)  in buscaremails" :key="i">
          <b-col cols=3>{{email.placa}}</b-col>
          <b-col cols=3>{{email.nome}}</b-col>
          <b-col cols=3>{{email.empresa}}</b-col>
          <b-col cols=3>{{email.email}}</b-col>
          
        </b-row>
      </b-container>

      <b-button class="mt-3" block @click="hideModal">Fechar</b-button>
    </b-modal>
  </div>
</template>


<style scoped>
.botao-inline{
  display: inline-block;
}
.titulo{
  font-weight: 900;
}
</style>